import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { getCategories } from '../../redux/thunks/categories';
import { addBacklink } from '../../redux/thunks/backlinks';
import { getErrorMessage } from '../../utils/helpers/form';
import { isURLValid } from '../../utils/helpers/valid';
import ErrorMessage from '../../components/error-message/error-message.component';
import BacklinksList from '../../components/backlinks-list/backlinks-list.component';

const Backlinks = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { categories } = useSelector((state) => state.entities.categories);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    dispatch(getCategories({}));
  }, []);

  const clearAllErrors = () => {
    clearErrors('invalid');
    clearErrors('domain');
  };

  useEffect(() => {
    watch(() => clearAllErrors());
  }, [watch, clearErrors]);

  const handleCategoryChange = (e) => {
    if (!e.target.value || !e.target.value.length) {
      return;
    }

    const foundCategory = categories.find(
      ({ name }) => name === e.target.value
    );
    if (!foundCategory) {
      return;
    }

    const existingCategory = selectedCategories.find(
      ({ _id }) => _id === foundCategory._id
    );
    if (existingCategory) {
      return;
    }

    clearAllErrors();

    setSelectedCategories([...selectedCategories, foundCategory]);
  };

  const deselectCategory = (categoryId) => {
    setSelectedCategories((prev) =>
      prev.filter(({ _id }) => _id !== categoryId)
    );
  };

  const handleAddBacklink = (formData) => {
    const { domain } = formData;

    if (!domain || !domain.trim().length) {
      return setError('domain', {
        type: 'invalid',
        message: 'יש להזין דומיין',
      });
    }

    if (!isURLValid(domain)) {
      return setError('domain', {
        type: 'invalid',
        message: 'דומיין לא תקין',
      });
    }

    if (!selectedCategories.length) {
      return setError('domain', {
        type: 'invalid',
        message: 'יש לבחור לפחות קטגוריה אחת',
      });
    }

    const onSuccess = (message) => {
      enqueueSnackbar(message, { variant: 'success' });
      setValue('domain', '');
    };

    const onError = (error) => enqueueSnackbar(error, { variant: 'error' });

    dispatch(addBacklink({
      domain: domain.trim(),
      categories: selectedCategories.map(({ _id }) => _id),
      onSuccess,
      onError,
    }));
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    }}>
      <Card>
        <Card.Body>
          <Card.Text
            style={{
              display: 'flex',
              gap: '1rem',
            }}
          >
            <Form.Control
              placeholder="דומיין"
              type="text"
              {...register('domain', {
                required: true,
              })}
            />
            <Form.Select onChange={handleCategoryChange}>
              <option>בחר קטגוריה</option>
              {categories.map(({ _id, name }) => (
                <option key={_id} value={name}>
                  {name}
                </option>
              ))}
            </Form.Select>
            <Button variant="primary" onClick={handleSubmit(handleAddBacklink)}>
              הוסף
            </Button>
          </Card.Text>
          {errors?.domain && (
            <p>
              <ErrorMessage error={getErrorMessage(errors?.domain?.type, errors?.domain?.message)} />
            </p>
          )}
          {selectedCategories.length > 0 && (
            <Card.Subtitle>
              <span>קטגוריות שנבחרו:</span>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                }}
              >
                {selectedCategories.map(({ _id, name }) => (
                  <span
                    key={_id}
                    style={{
                      fontSize: '0.6rem',
                      margin: '0.3rem',
                      padding: '0.5rem',
                      border: '1px solid #ccc',
                      borderRadius: '0.5rem',
                      backgroundColor: '#f5f5f5',
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: '0.1rem',
                    }}
                  >
                    <span>{name}</span>
                    <span
                      style={{
                        color: 'red',
                        cursor: 'pointer',
                        fontSize: '0.8em',
                      }}
                      onClick={() => deselectCategory(_id)}
                    >
                      מחק
                    </span>
                  </span>
                ))}
              </div>
            </Card.Subtitle>
          )}
        </Card.Body>
      </Card>

      <BacklinksList manage={true} />
    </div>
  );
};

export default Backlinks;
